import { IHttpInterceptor, IHttpInterceptorFactory } from "angular";

interface TClass<T> {
    new (...args: any): T;
}

/**
 * Return a factory function that willuse the same dependency injection
 * annotations as the constructor of the HttpInterceptor class being created.
 * @param tclass The class object to be constructed.
 */
export function HttpInterceptorFactory<T extends IHttpInterceptor>(tclass: TClass<T>): IHttpInterceptorFactory {
    const factory = function(...args: any[]) {
        const instance = new tclass(...args);
        // AngularJS doesn't treat interceptors as classes, so it doesn't call the interface
        // methods with the correct "this" bindings. Explicitly bind the methods to the interceptor here.
        if (instance.request) {
            instance.request = instance.request.bind(instance);
        }
        if (instance.requestError) {
            instance.requestError = instance.requestError.bind(instance);
        }
        if (instance.response) {
            instance.response = instance.response.bind(instance);
        }
        if (instance.responseError) {
            instance.responseError = instance.responseError.bind(instance);
        }
        return instance;
    }
    factory.$inject = tclass.$inject;
    return factory;
}
